import React, { useState, useEffect, memo } from "react";
import { connect } from "react-redux";
import { map, reduce, get, filter, castArray } from "lodash";
import { hot } from "react-hot-loader";
import isImage from "is-image";
import Img from "react-image";
import {
  Avatar,
  Button,
  IconButton,
  Box,
  InputLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Paper
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import DragHandleIcon from "@material-ui/icons/DragIndicator";
import { makeStyles } from "@material-ui/styles";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";
import actions from "../../../../_actions";

const useStyles = makeStyles(theme => ({
  tab: {
    minHeight: 0,
    "& span:first-child": {
      flexDirection: "row",
      "& svg": {
        marginRight: theme.spacing(1)
      }
    }
  },
  fileItem: {
    zIndex: 4,
    cursor: "pointer"
  },
  dragHandle: {
    cursor: "move",
    marginRight: theme.spacing(1),
    display: "flex"
  },
  avatar: {
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: "bold",
    display: "inline-flex",
    verticalAlign: "middle",
    "& img": {
      maxHeight: 48,
      maxWidth: 48,
      width: "100%"
    }
  }
}));

const File = props => {
  const classes = useStyles();
  const [files, setFiles] = useState(props.value || []);

  const addFile = React.useCallback(file => {
    const newFiles = [...files, file];
    props.onChange(newFiles);
  });

  const removeFile = React.useCallback(file => {
    const newFiles = reduce(
      files,
      (acc, f) => {
        if (file.fullPath !== f.fullPath) {
          acc.push(f);
        }

        return acc;
      },
      []
    );

    props.onChange(newFiles);
  });

  useEffect(() => {
    if (get(props.value, "length", 0) !== files.length) {
      setFiles(props.value);
      props.updateFileManager({
        selectedFiles: props.value,
        addFile,
        removeFile
      });
    }
  }, [props.value]);

  useEffect(() => {
    // if (get(props.value, "length", 0) !== files.length) {
    props.updateFileManager({
      selectedFiles: files,
      addFile,
      removeFile
    });
    // }
  }, [files]);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newFiles = arrayMove(files, oldIndex, newIndex);
    setFiles(newFiles);
    props.onChange(newFiles);
  };

  const SortableItem = SortableElement(({ file }) => (
    <Paper elevation={2} className={classes.fileItem}>
      <ListItem ContainerComponent="div">
        <span className={classes.dragHandle}>
          <DragHandleIcon />
        </span>
        <ListItemAvatar>
          <Avatar className={classes.avatar}>
            {isImage(file.name) ? (
              <Img src={file.downloadURL} />
            ) : (
              file.name
                .split(".")
                .slice(-1)
                .pop() || "?"
            )}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={file.fullPath}
          secondary={file.contentType}
        ></ListItemText>
        <ListItemSecondaryAction>
          <IconButton
            onClick={() => removeFile(file)}
            edge="end"
            aria-label="remove"
          >
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </Paper>
  ));

  const SortableList = SortableContainer(({ selectedFiles }) => (
    <List component="div">
      {map(selectedFiles, (file, index) => (
        <SortableItem index={index} key={file.fullPath} file={file} />
      ))}
    </List>
  ));

  return (
    <div>
      <Box mb={1}>
        <InputLabel>{props.label}</InputLabel>
      </Box>

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          props.updateFileManager({
            show: true,
            selectedFiles: files || [],
            addFile: addFile,
            removeFile: removeFile
          });
        }}
      >
        Choose Image
      </Button>

      {files.length ? (
        <Box mt={2}>
          <SortableList
            pressDelay={200}
            pressThreshold={5}
            selectedFiles={files}
            onSortEnd={onSortEnd}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default hot(module)(
  memo(
    connect(null, {
      updateFileManager: actions.updateFileManager
    })(File),
    (pp, np) => get(pp, "value.length", 0) === get(np, "value.length", 0)
  )
);

// import React, { useState, useEffect, memo } from "react";
// import { map, filter, castArray } from "lodash";
// import { hot } from "react-hot-loader";
// import isImage from "is-image";
// import Img from "react-image";
// import Dialog from "../../Dialog";
// import FileList from "../../../FileList";
// import {
//   Avatar,
//   Button,
//   IconButton,
//   Box,
//   InputLabel,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   ListItemSecondaryAction,
//   Paper
// } from "@material-ui/core";
// import DeleteIcon from "@material-ui/icons/Delete";
// import DragHandleIcon from "@material-ui/icons/DragIndicator";
// import { makeStyles } from "@material-ui/styles";
// import {
//   SortableContainer,
//   SortableElement,
//   arrayMove
// } from "react-sortable-hoc";

// const useStyles = makeStyles(theme => ({
//   tab: {
//     minHeight: 0,
//     "& span:first-child": {
//       flexDirection: "row",
//       "& svg": {
//         marginRight: theme.spacing(1)
//       }
//     }
//   },
//   fileItem: {
//     zIndex: 4,
//     cursor: "pointer"
//   },
//   dragHandle: {
//     cursor: "move",
//     marginRight: theme.spacing(1),
//     display: "flex"
//   },
//   avatar: {
//     textTransform: "uppercase",
//     fontSize: "12px",
//     fontWeight: "bold",
//     display: "inline-flex",
//     verticalAlign: "middle"
//   }
// }));

// const File = props => {
//   const classes = useStyles();
//   const [files, setFiles] = useState(props.value || []);
//   const [showDialog, setShowDialog] = useState(false);

//   useEffect(() => {
//     setFiles(props.value || []);
//   }, [props.value]);

//   const addFile = file => {
//     const newFiles = [...files, file];
//     setFiles(newFiles);
//     props.onChange(newFiles);
//   };

//   const removeFile = file => {
//     const removeFiles = map(castArray(file), file => file.fullPath);
//     const newFiles = filter(files, f => !removeFiles.includes(f.fullPath));
//     setFiles(newFiles);
//     props.onChange(newFiles);
//   };

//   const onSortEnd = ({ oldIndex, newIndex }) => {
//     const newFiles = arrayMove(files, oldIndex, newIndex);
//     setFiles(newFiles);
//     props.onChange(newFiles);
//   };

//   const SortableItem = SortableElement(({ file }) => (
//     <Paper elevation={2} className={classes.fileItem}>
//       <ListItem ContainerComponent="div">
//         <span className={classes.dragHandle}>
//           <DragHandleIcon />
//         </span>
//         <ListItemAvatar>
//           <Avatar className={classes.avatar}>
//             {isImage(file.name) ? (
//               <Img src={file.downloadURL} />
//             ) : (
//               file.name
//                 .split(".")
//                 .slice(-1)
//                 .pop() || "?"
//             )}
//           </Avatar>
//         </ListItemAvatar>
//         <ListItemText
//           primary={file.fullPath}
//           secondary={file.contentType}
//         ></ListItemText>
//         <ListItemSecondaryAction>
//           <IconButton
//             onClick={() => removeFile(file)}
//             edge="end"
//             aria-label="remove"
//           >
//             <DeleteIcon />
//           </IconButton>
//         </ListItemSecondaryAction>
//       </ListItem>
//     </Paper>
//   ));

//   const SortableList = SortableContainer(({ selectedFiles }) => (
//     <List component="div">
//       {map(selectedFiles, (file, index) => (
//         <SortableItem index={index} key={file.fullPath} file={file} />
//       ))}
//     </List>
//   ));

//   return (
//     <div>
//       <Box mb={1}>
//         <InputLabel>{props.label}</InputLabel>
//       </Box>

//       <Button
//         variant="contained"
//         color="primary"
//         onClick={() => setShowDialog(true)}
//       >
//         Choose Image
//       </Button>

//       {files.length ? (
//         <Box mt={2}>
//           <SortableList
//             pressDelay={100}
//             selectedFiles={files}
//             onSortEnd={onSortEnd}
//           />
//         </Box>
//       ) : null}
//       <Dialog
//         maxWidth="lg"
//         title="Files"
//         open={showDialog}
//         onClose={() => setShowDialog(false)}
//       >
//         <FileList
//           selectedFiles={files || []}
//           addFile={addFile}
//           removeFile={removeFile}
//         />
//       </Dialog>
//     </div>
//   );
// };

// export default hot(module)(memo(File, () => true));
